import { DOCUMENT, Location } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';
import { I18NextModule } from 'angular-i18next';
import { BaseComponent } from 'src/app/_shared/components/base/base.component';
import { IconComponent } from 'src/app/common/icon/icon.component';
import { METADATA_SERVICE, MetadataService } from 'src/app/common/metadata/metadata.service';
import { capacitorDownloadFile } from 'src/app/common/utils/helpers';
import { VideoLoaderDirective } from 'src/app/common/video-loader/video-loader.directive';
import { FooterComponent } from '../../_shared/components/footer/footer.component';
import { HeaderComponent } from '../../_shared/components/header/header.component';

@Component({
  selector: 'sharry-what',
  standalone: true,
  templateUrl: './what.component.html',
  styleUrls: ['./what.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    I18NextModule,
    MatButtonModule,
    IconComponent,
    VideoLoaderDirective,
    HeaderComponent,
    FooterComponent,
    RouterModule,
  ],
})
export class WhatComponent extends BaseComponent implements OnInit, OnDestroy {
  capacitorDownloadFile = capacitorDownloadFile;

  constructor(
    @Inject(METADATA_SERVICE) private metadataService: MetadataService,
    private location: Location,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document,
  ) {
    super();
  }

  ngOnInit(): void {
    this.renderer.addClass(this.document.querySelector('html'), 'shrink');
    this.metadataService.setMetadataPage('what-is-sharryland', this.location.path());
  }

  ngOnDestroy(): void {
    this.metadataService.clean();
    this.renderer.removeClass(this.document.querySelector('html'), 'shrink');
  }
}
